import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TeamPage } from "@/features/team/TeamPage";

const search = z.object({
  view: z.enum(["table", "cards"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/team/")({
  validateSearch: search,
  component: () => <TeamPage search={Route.useSearch()} />,
});
